module.exports = __webpack_public_path__ + "static/media/relationaldb.da8b4203.jfif";